import { createUseStyles } from 'react-jss'
import { BLUE } from '@omnilert/components'

export default createUseStyles({
  breadcrumb: {
    display: 'flex',
    fontFamily: 'BentonSansMedium',
    listStyle: 'none'
  },
  icon: {
    margin: '0 10px'
  },
  link: {
    fontSize: '16px',
    fontWeight: '500',
    color: BLUE
  }
})

